/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

// SOURCE_OF_TRUTH_OPTIONS constant is used for filtering on table data.
export const SOURCE_OF_TRUTH_OPTIONS = [
  { label: "Toast", value: "toast" },
  { label: "Seven Shifts", value: "seven_shifts" },
  { label: "Manual", value: "manual" },
];


// SOURCE_OF_TRUTH_FETCH_OPTIONS is used for fetching data from server.
export const SOURCE_OF_TRUTH_FETCH_OPTIONS = [
  { label: "Toast", value: "toast" },
  { label: "Seven Shifts", value: "seven_shifts" },
  { label: "Manual", value: "manual" },
];

/**
 * Front/Back of House classification for jobs. Mirrors the backend Job#department
 * enum and is the single source for the column badge, the row action menu and the
 * Jobs filter, so the labels stay identical across all three.
 */
export const DEPARTMENT_OPTIONS = [
  { label: "Unmapped", value: "unmapped" },
  { label: "FOH", value: "foh" },
  { label: "BOH", value: "boh" },
];

export const DEPARTMENT_LABELS = Object.fromEntries(
  DEPARTMENT_OPTIONS.map(({ value, label }) => [value, label])
);

export const STATUS_OPTIONS = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
  { label: "Uninvited", value: "uninvited" },
];
